/** The last searches made on this device, per person, newest first. Kept in this browser only; a blocked store keeps none. */
const MAX = 5
const key = (userId: string) => `boss-chat:recent-searches:${userId}`

export function loadRecentSearches(userId: string): string[] {
  try {
    const saved: unknown = JSON.parse(localStorage.getItem(key(userId)) ?? '[]')
    return Array.isArray(saved) ? saved.filter((s): s is string => typeof s === 'string').slice(0, MAX) : []
  } catch {
    return []
  }
}

export function rememberSearch(userId: string, query: string): string[] {
  const q = query.trim()
  if (!q) return loadRecentSearches(userId)
  const next = [q, ...loadRecentSearches(userId).filter((s) => s.toLowerCase() !== q.toLowerCase())].slice(0, MAX)
  try {
    localStorage.setItem(key(userId), JSON.stringify(next))
  } catch {
    // Storage blocked: searching still works, without recents.
  }
  return next
}

export function clearRecentSearches(userId: string): void {
  try {
    localStorage.removeItem(key(userId))
  } catch {
    // Nothing kept to clear.
  }
}
